// extracted by mini-css-extract-plugin
export default {"post":"Home_post__BENVH","postLink":"Home_postLink__RVcQG","alert":"Home_alert__KtEaQ"};